import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.trainStatus;

const TrainStatusData = createSelector([selector], (state) => state);

export default {
  TrainStatusData
};
